export default "__VITE_ASSET__CxqYFVso__"